import { render } from "./phone-list.vue?vue&type=template&id=0f25b35c&scoped=true"
import script from "./phone-list.vue?vue&type=script&lang=js"
export * from "./phone-list.vue?vue&type=script&lang=js"

import "./phone-list.vue?vue&type=style&index=0&id=0f25b35c&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f25b35c"]])

export default __exports__